import {
    GET_ALL_QUOTES_BY_OPPURTUNITY,
    GET_ALL_OPPORTUNITY_BY_USER
} from '../ActionTypes/ActionTypes';

import QuoteService from '../Services/QuoteService';


export const getAllQuotesByOppurtunity = (oppurtunityId, userId) => async (dispatch) => {
    try {

        const res = await QuoteService.getAllQuotesByOppurtunity(oppurtunityId, userId);

        dispatch({
            type: GET_ALL_QUOTES_BY_OPPURTUNITY,
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};

export const getAllQuotesByQuoteIdsForVisualization = (requestData) => async (dispatch) => {
    try {

        
            const res = await QuoteService.getAllQuotesByQuoteIdsForVisualization(requestData);
       
        dispatch({
            type: GET_ALL_QUOTES_BY_OPPURTUNITY,
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};
export const getQuotesForBundleInVisualization = (requestData) => async (dispatch) => {
    try {
        
            const res = await QuoteService.getQuotesForBundledQuotes(requestData);
       
        dispatch({
            type: GET_ALL_QUOTES_BY_OPPURTUNITY,
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};


export const getOpportunityByUser = (userId) => async (dispatch) => {
    try {

        const res = await QuoteService.getOpportunityByUser(userId);

        dispatch({
            type: GET_ALL_OPPORTUNITY_BY_USER,
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};

export const saveOpportunityDetails = (opportunity) => async (dispatch) => {
    try {
        const res = await QuoteService.saveOpportunityDetails(opportunity);

        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};

export const saveCountryHeadCount = (countryHeadCount) => async (dispatch) => {
    try {
        const res = await QuoteService.saveCountryHeadCount(countryHeadCount);

        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};
export const validateCountryHeadCount = (countryHeadCount) => async (dispatch) => {
    try {
        const res = await QuoteService.validateCountryHeadCount(countryHeadCount);

        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};

export const getQuoteCountryHeadCounts = (quoteId) => async (dispatch) => {
    try {
        const res = await QuoteService.getQuoteCountryHeadCounts(quoteId);

        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};

export const getAllInPrice = (allInPrice) => async (dispatch) => {
    try {
        const res = await QuoteService.getAllInPrice(allInPrice);

        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};

export const saveQuoteDetails = (quote) => async (dispatch) => {
    try {
        const res = await QuoteService.saveQuoteDetails(quote);

        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};

export const getQuoteDetails = (quoteId) => async (dispatch) => {
    try {
        const res = await QuoteService.getQuoteDetails(quoteId);

        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};

export const getQuoteDetailsForBankOfHours = (quoteId) => async (dispatch) => {
    try {
        const res = await QuoteService.getQuoteDetailsForBankOfHours(quoteId);

        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};

export const getDuplicateQuoteDetails = (quoteId, userId) => async (dispatch) => {
    try {
        const res = await QuoteService.getDuplicateQuoteDetails(quoteId, userId);

        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};

export const getQuoteHistory = (quoteId) => async (dispatch) => {
    try {
        const res = await QuoteService.getQuoteHistory(quoteId);

        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};

export const getServiceDistribution = (companyId, productId, productVariationId, quoteId) => async (dispatch) => {
    try {
        const res = await QuoteService.getServiceDistribution(companyId, productId, productVariationId, quoteId);

        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};

export const saveServiceDistribution = (serviceDistribution) => async (dispatch) => {
    try {
        const res = await QuoteService.saveServiceDistribution(serviceDistribution);

        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};

export const saveQuoteHistory = (quoteHistory) => async (dispatch) => {
    try {
        const res = await QuoteService.saveQuoteHistory(quoteHistory);

        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};

export const updateQuoteStatus = (quoteStatusId, quoteId, userId) => async (dispatch) => {
    try {
        const res = await QuoteService.updateQuoteStatus(quoteStatusId, quoteId, userId);

        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};


export const getSAMLeadership = (roleId) => async (dispatch) => {
    try {
        const res = await QuoteService.getSAMLeadership(roleId);

        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};

export const getUsersByRole = (roleId) => async (dispatch) => {
    try {
        const res = await QuoteService.getUsersByRole(roleId);

        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};

export const getPendingApprovalRoles = (quoteId, statusId) => async (dispatch) => {
    try {
        const res = await QuoteService.getPendingApprovalRoles(quoteId, statusId);

        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};

export const saveNote = (newNote) => async (dispatch) => {
    try {
        const res = await QuoteService.saveNote(newNote);

        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};
export const getQuotePricingDetails = (quoteId) => async (dispatch) => {
    try {
        const res = await QuoteService.GetQuotePricingDetails(quoteId);

        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};
export const getBlendedRevenueDistribution = (quoteId) => async (dispatch) => {
    try {

        const res = await QuoteService.GetBlendedRevenueDistribution(quoteId);

        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};
export const SaveQuoteCalculationsNonEAP = (nonEapQuoteCalulation) => async (dispatch) => {
    try {
        const res = await QuoteService.SaveQuoteCalculationsNonEAP(nonEapQuoteCalulation);

        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};
export const SaveQuoteCalculations = (saveQuoteCalculationParam) => async (dispatch) => {
    try {
        const res = await QuoteService.SaveQuoteCalculations(saveQuoteCalculationParam);

        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};
export const removeQuoteCountries = (removeCountries) => async (dispatch) => {
    try {
        const res = await QuoteService.removeQuoteCountries(removeCountries);

        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};
export const uploadRFPFile = async(quoteId, formData) =>  {
   
    return await QuoteService.uploadRFPFile(quoteId, formData);
}
export const downloadRFPFile = (fileName) => async (dispatch) => {
    try {
        const res = await QuoteService.downloadRFPFile(fileName);

        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    };
}

export const saveDeliveryStaffProductivityVariationAsync = (deliveryStaffProductivityVariation) => async (dispatch) => {
    try {
        const res = await QuoteService.saveDeliveryStaffProductivityVariation(deliveryStaffProductivityVariation);

        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};

export const saveStaffCostDepartmentVariationAsync = (staffCostDepartmentVariation) => async (dispatch) => {
    try {
        const res = await QuoteService.saveStaffCostDepartmentVariation(staffCostDepartmentVariation);

        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};

export const saveSessionUsageComponentTypeVariationAsync = (sessionUsageComponentTypeVariation) => async (dispatch) => {
    try {
        const res = await QuoteService.saveSessionUsageComponentTypeVariation(sessionUsageComponentTypeVariation);

        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};

export const saveExternalCostsVariationAsync = (externalCostsVariation) => async (dispatch) => {
    try {
        const res = await QuoteService.saveExternalCostsVariation(externalCostsVariation);

        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};
export const saveBankOfHoursVariation = (bankOfHoursVariation) => async (dispatch) => {
    try {
        const res = await QuoteService.saveBankOfHoursVariation(bankOfHoursVariation);

        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};
export const saveCountryUtilizationVariation = (countryUtilizationVariation) => async (dispatch) => {
    try {
        const res = await QuoteService.saveCountryUtilizationVariation(countryUtilizationVariation);

        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};

export const calculateBundleDiscount = (calculateBundleParams) => async () => {
    try {
        const res = await QuoteService.calculateBundleDiscount(calculateBundleParams);

        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};

export const getAllBundlesByUserAndOpportunityId = (bundleParams) => async () => {
    try {
        const res = await QuoteService.getAllBundlesByUserAndOpportunityId(bundleParams);

        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};

export const getBundleDetailsByBundleId = (bundleId) => async () => {
    try {
        const res = await QuoteService.getBundleDetailsByBundleId(bundleId);

        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};

export const getBundleUploadDataByBundleId = (bundleId) => async () => {
    try {
        const res = await QuoteService.getBundleUploadDataByBundleId(bundleId);

        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};

export const removeBundle = (removeBundleParams) => async () => {
    try {
        const res = await QuoteService.removeBundle(removeBundleParams);

        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};

export const refreshBundle = (refreshBundleParams) => async () => {
    try {
        const res = await QuoteService.refreshBundle(refreshBundleParams);

        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};

export const validateBundle = (validateBundleParams) => async () => {
    try {
        const res = await QuoteService.validateBundle(validateBundleParams);

        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};

export const duplicateBundle = (duplicateBundleParams) => async () => {
    try {
        const res = await QuoteService.duplicateBundle(duplicateBundleParams);

        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};

export const submitBundle = (submitBundleParams) => async () => {
    try {
        const res = await QuoteService.submitBundle(submitBundleParams);

        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};

export const approveBundle = (approveBundleParams) => async () => {
    try {
        const res = await QuoteService.approveBundle(approveBundleParams);

        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};

export const getAllBundles = (opportunityId, userId) => async () => {
    try {
        const res = await QuoteService.getAllBundles(opportunityId, userId);

        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};

export const getBundleNotes = (bundleId) => async () => {
    try {
        const res = await QuoteService.getBundleNotes(bundleId);

        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};

export const saveBundleNote = (bundleNote) => async () => {
    try {
        const res = await QuoteService.saveBundleNote(bundleNote);

        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};

export const getBundleDetailsForManageBundles = (bundleDetailsParams) => async () => {
    try {
        const res = await QuoteService.getBundleDetailsForManageBundles(bundleDetailsParams);

        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};

export const rejectBundle = (rejectBundleObj) => async () => {
    try {
        const res = await QuoteService.rejectBundle(rejectBundleObj);

        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};

export const saveBundleName = (saveBundleNameObj) => async () => {
    try {
        const res = await QuoteService.saveBundleName(saveBundleNameObj);

        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};

export const saveCrmBundleId = (saveCrmBundleIdObj) => async () => {
    try {
        const res = await QuoteService.saveCrmBundleId(saveCrmBundleIdObj);

        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};

export const syncQuotes = (userId) => async () => {
    try {
        const res = await QuoteService.syncQuotes(userId);

        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};

export const approveQuote = (approveQuoteObj) => async () => {
    try {
        const res = await QuoteService.approveQuote(approveQuoteObj);

        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};

export const rejectQuote = (rejectQuoteObj) => async () => {
    try {
        const res = await QuoteService.rejectQuote(rejectQuoteObj);

        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};

export const validateQuote = (validateQuoteObj) => async () => {
    try {
        const res = await QuoteService.validateQuote(validateQuoteObj);

        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};

export const validateBundleApproval = (validateBundleApprovalObj) => async () => {
    try {
        const res = await QuoteService.validateBundleApproval(validateBundleApprovalObj);

        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};

export const getPendingApprovalRolesForBundle = (bundleId, statusId) => async (dispatch) => {
    try {
        const res = await QuoteService.getPendingApprovalRolesForBundle(bundleId, statusId);

        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};

export const checkApproversRequired = (quoteId) => async (dispatch) => {
    try {
        const res = await QuoteService.checkApproversRequired(quoteId);

        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};

export const saveApprovalAssignments = (assignmentsObj) => async (dispatch) => {
    try {
        const res = await QuoteService.saveApprovalAssignments(assignmentsObj);

        return Promise.resolve(res);
    } catch (err) {
        console.log(err);
    }
};